'use strict';

import MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: Array<MapProperty> = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'namePropagation',

        defaultValue: false,
    },
    {
        localName: 'imageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeImage',

        defaultValue: false,
    },
    {
        localName: 'imageMediumId',

        defaultValue: '',
    },
    {
        localName: 'siteId',

        defaultValue: 0,
    },
    {
        localName: 'toursCount',

        defaultValue: 0,
    },
    {
        localName: 'publishedToursCount',

        defaultValue: 0,
    },
    {
        localName: 'deleted',

        defaultValue: false,
    },
    {
        localName: 'menuPosition',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'keypadNumber',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'contentStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'menuStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'isBackButtonOverride',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'backButtonStyleId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'siteObjectId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'int1',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'int2',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'int3',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'int4',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'bool1',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'bool2',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'tourId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'menuTypeId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'menuSubTypeId',

        defaultValue: 0,
        optional: true,
    },
];

export default MAPPINGS;
